import { Component, OnInit, OnDestroy } from '@angular/core';
import { BasePageComponent } from '../base-page';
import { Spinkit } from 'ng-http-loader';
import { IAppState } from 'src/app/interfaces/app-state';
import { Store } from '@ngrx/store';
import { HttpService } from 'src/app/services/http/http.service';
import { Router } from '@angular/router';
import { TCModalService } from '../../ui/services/modal/modal.service';
import { Content } from '../../ui/interfaces/modal';
import { HttpErrorResponse } from '@angular/common/http';
import { element } from 'protractor';
import Swal from 'sweetalert2';



@Component({
  selector: 'app-addon',
  templateUrl: './addon.component.html',
  styleUrls: ['./addon.component.scss']
})
export class AddonComponent extends BasePageComponent implements OnInit, OnDestroy {
  public spinkit = Spinkit;
  restoID
  rstoName
  resto
  rstoID
  rstoAdd
  rstopocName
  errorMessage
  pocID
  rstoEmail
  restaurant_id
  restaurant_image
  algns_name
  alrgoption
  allergens
  addon_price = 0
  dietPref
  addon_name
  serial_num
  dietraywithdots
  allergenwithdots
  detail_addon
  addon_id
  addon_details = []


  constructor(store: Store<IAppState>, httpSv: HttpService, private router: Router, private modal: TCModalService,) {
    super(store, httpSv);
    this.pageData = {
      title: '',
      loaded: true,
      breadcrumbs: [
        {
          title: 'Addon'
        }
      ]
    };
  }
  ngOnInit() {
    this.restoID = localStorage.getItem('restoID');
    super.ngOnInit();
    this.getdata();
    this.getAllergens();
    this.getDiestpref();
    this.getAddon_details();
  }
  ngOnDestroy() {
    super.ngOnDestroy();
  }
  getdata() {
    this.httpSv.getReturant(this.restoID).subscribe(
      response => {
        if (response['status'] == true) {
          this.resto = response['result'].data;
          this.rstoName = this.resto['restaurant_name']
          this.rstoID = this.resto['restaurant_unique_id']
          this.rstoAdd = this.resto['restaurant_address']
          this.rstopocName = this.resto['restaurant_poc_name']
          this.pocID = this.resto['restaurant_poc_number']
          this.rstoEmail = this.resto['restaurant_email']
          this.restaurant_id = this.resto['restaurant_id'];
          this.restaurant_image = this.resto['restaurant_image'];
        }
      }, (err: HttpErrorResponse) => {
        this.errorMessage = err;
        if (err.status == 401 || err.status == 500) {
          this.logout();
        }
      }
    )
  }
  logout() {
    this.httpSv.logout().subscribe(
      response => {
        localStorage.clear();
        setTimeout(() => {
          this.router.navigate(['/public/sign-in'])
        })
      },
      err => {
        console.log(err);
      }
    );
  }
  allDiestpref = []
  getDiestpref() {
    this.httpSv.getallActiveRestoDiestpref().subscribe(
      response => {
        if (response['status'] == true) {
          this.allDiestpref = response['result'].data;

        }
      }, (err: HttpErrorResponse) => {
        this.errorMessage = err.error.message;
        if (err.status == 401 || err.status == 500) {
          this.logout();
        }
      }
    )
  }

  getAllergens() {
    this.httpSv.getallActiveRestoAllergens().subscribe(
      response => {
        if (response['status'] == true) {
          this.allergens = response['result'].data;
          this.allergens.forEach(element => {
            this.algns_name = element.allergens_name;
          });
        }
      }, (err: HttpErrorResponse) => {
        this.errorMessage = err.error.message;
        if (err.status == 401 || err.status == 500) {
          this.logout();
        }
      }
    )
  }
  addonAllergen = []
  addonDietary = []
  openModals_addon<T>(body: Content<T>, header: Content<T> = null, footer: Content<T> = null, options: any = null) {
    this.addon_name = null;
    this.alrgoption = null;
    this.dietPref = null;
    this.modal.open({
      body: body,
      header: header,
      footer: footer,
      options: options
    });
  }
  openModalsView_detail<T>(body: Content<T>, header: Content<T> = null, footer: Content<T> = null, options: any = null, value) {
    this.modal.open({
      body: body,
      header: header,
      footer: footer,
      options: options
    });
    let filteredArray = this.correctAddonDetails?.filter((item) => {
      if (item.addon_name === value) {
        return item
      }
    })
    this.httpSv.addondetailsById(filteredArray[0]?.id).subscribe(res => {
      if (res['status'] == true) {
        this.detail_addon = res['result'].data
        this.addon_name = res['result'].data.addon_name
        this.addon_price = this.addon_price

        this.detail_addon.forEach(data => {
          if (data.restaurant_addon_allegens) {
            this.addonAllergen = data.restaurant_addon_allegens.map(value => value.allergens_name)
          }
          if (data.restaurant_addon_dietary) {
            this.addonDietary = data.restaurant_addon_dietary.map(value => value.diet_preference_name)

          }
        })
      }
    }, (err: HttpErrorResponse) => {
      this.errorMessage = err.error.message;
      if (err.status == 401 || err.status == 500) {
        this.logout();
      }
    })

  }
  delete_addon_id
  openModals_delete<T>(body: Content<T>, header: Content<T> = null, footer: Content<T> = null, options: any = null, value) {
    this.modal.open({
      body: body,
      header: header,
      footer: footer,
      options: options
    });
    let filteredArray = this.correctAddonDetails?.filter((item) => {
      if (item.addon_name === value) {
        return item
      }
    })
    this.delete_addon_id = filteredArray[0]?.id;
    // console.log(this.delete_addon_id)
  }

  Edit_Modals<T>(body: Content<T>, header: Content<T> = null, footer: Content<T> = null, options: any = null, value) {
    this.modal.open({
      body: body,
      header: header,
      footer: footer,
      options: options
    });
    const _modal: any = document.querySelector('tc-modal');
    _modal.remove();
    this.addon_id = value
    this.httpSv.addondetailsById(value).subscribe(res => {
      if (res['status'] == true) {
        this.detail_addon = res['result'].data
        this.detail_addon.forEach(data => {
          this.addon_name = data.addon_name
          this.addon_price = this.addon_price
          if (data.restaurant_addon_allegens) {
            this.addonAllergen = data.restaurant_addon_allegens.map(value => value.allergens_id)
          }
          if (data.restaurant_addon_dietary) {
            this.addonDietary = data.restaurant_addon_dietary.map(value => value.diet_preference_id)

          }
        })
      }
    }, (err: HttpErrorResponse) => {
      this.errorMessage = err.error.message;
      if (err.status == 401 || err.status == 500) {
        this.logout();
      }
    })
  }
  close_edit() {
    this.modal.close();
  }
  close_Details() {
    this.modal.close();
  }
  delete_addon() {
    this.httpSv.delete_addon(this.delete_addon_id).subscribe(res => {
      if (res['status'] == true) {
        this.modal.close();
        this.getAddon_details();
      }
    })
  }
  id
  correctAddonDetails = []
  getAddon_details() {

    this.httpSv.getAddon_details().subscribe((res: any) => {
      this.correctAddonDetails = res['result']?.data;
      // console.log(this.correctAddonDetails)
    }, (err: HttpErrorResponse) => {
      if(err.error.message == 'No add on Found in this restaurant'){
        this.correctAddonDetails = []
      }
    })



    this.httpSv.getAddon_details().subscribe(res => {
      // this.correctAddonDetails = res['result']?.data;
      // console.log(this.correctAddonDetails)
      if (res['status'] == true) {
        this.addon_details = res['result'].data
        this.addon_details.forEach((ele, index) => [
          ele.id = index + 1
        ])

      }
    }, (err: HttpErrorResponse) => {
      this.errorMessage = err.error.message;
      if(err.error.message == 'No add on Found in this restaurant'){
        this.addon_details = []
      }
      if (err.status == 401 || err.status == 500) {
        this.logout();
      }
    })
  }
  Creat_addon(addon_name, alrgoption, dietPref) {
    this.httpSv.create_addOn(addon_name, this.addon_price, alrgoption, dietPref).subscribe(res => {
      if (res['status'] == true) {
        const _modal: any = document.querySelector('tc-modal');
        _modal.remove();
        this.getAddon_details();
        Swal.fire("Add on created")
      }
    }, (err: HttpErrorResponse) => {
      this.errorMessage = err.error.message;
      if (err.status == 401 || err.status == 500) {
        this.logout();
      }

    })
  }
  switch_toggle(status, id) {
    this.httpSv.addon_status(status, id).subscribe(res => {
      if (res['status'] == true) {
        this.ngOnInit();
      }
    }, (err: HttpErrorResponse) => {
      this.errorMessage = err.error.message;
      if (err.status == 401 || err.status == 500) {
        this.logout();
      }
    })
  }

  Update_addon(restaurant_addon_name, addonAllergen, addonDietary) {
    this.httpSv.updateAddon(this.addon_id, restaurant_addon_name, this.addon_price, addonAllergen, addonDietary).subscribe(res => {
      if (res['status'] == true) {
        const _modal: any = document.querySelector('tc-modal');
        _modal.remove();
        this.getAddon_details();
      }
    })
  }

  checkdietary(value) {
    if (value.length > 1) {
      return value[0].diet_preference_name + ' ' + '...';
    } else if (value.length == 1) {
      return value[0].diet_preference_name;
    }
  }
  checkALlergens(value) {
    if (value.length > 1) {
      return value[0].allergens_name + ' ' + '...';
    } else if (value.length == 1) {
      return value[0].allergens_name;
    }
  }
}
